// Generated from videos.verified.json: YouTube ids verified via oEmbed (dates in the JSON).
// Title and channel are exactly what oEmbed returned. Spanish first.
import type { ExerciseVideo } from '@/domain/types'

export const EXERCISE_VIDEOS: Record<string, ExerciseVideo[]> = {
  'bench-press': [
    {
      youtubeId: '7aQY3u0Dk-Q',
      title:
        'PRESS BANCA  - TECNICA, CONSEJOS, ERRORES... (TUTORIAL MAS COMPLETO SOBRE EL PRESS DE BANCA)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: '4Y2ZdHCOXok',
      title: 'How to PROPERLY Bench Press for Growth (5 Easy Steps)',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
  ],
  'incline-bench-press': [
    {
      youtubeId: 'DT4W8XkJZiY',
      title: 'Consigue un PECTORAL SUPERIOR ESTÉTICO con PRESS INCLINADO (y sus variantes)',
      channel: 'Fit Generation',
      lang: 'es',
    },
  ],
  'close-grip-bench-press': [
    {
      youtubeId: 'bnzaGiAyYVg',
      title:
        'PRESS CERRADO - con este truco gana fuerza y evita lesiones - ejercicio para triceps - bilboteam',
      channel: 'Bilbo Team Jesus Maria Varela',
      lang: 'es',
    },
    {
      youtubeId: 'Cv5nS1AH_jE',
      title: 'Close Grip Bench Pressing For Maximum Growth | Targeting The Muscle',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'dumbbell-bench-press': [
    {
      youtubeId: 'VbsK3Mmkguc',
      title: 'PRESS CON MANCUERNAS // Guía completa (Claves, secretos, errores ❌)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'QsYre__-aro',
      title: 'STOP Doing Dumbbell Press Like This (5 Mistakes Slowing Your Chest Gains)',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
  ],
  'incline-dumbbell-press': [
    {
      youtubeId: 'XbTgnX2vRhw',
      title: 'Sabias esto? - POSTURA CORRECTA EN PRESS INCLINADO CON MANCUERNAS',
      channel: 'Bilbo Team Jesus Maria Varela',
      lang: 'es',
    },
    {
      youtubeId: '0f6-uCUKqgA',
      title: 'Incline Dumbbell Press BETTER | Targeting The Muscle Series',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'dumbbell-fly': [
    {
      youtubeId: 'AYWpCfLcYYg',
      title: 'PECTORAL - Aperturas con Mancuernas',
      channel: 'Bilbo Team Jesus Maria Varela',
      lang: 'es',
    },
    {
      youtubeId: '_LwuS1PdbdM',
      title: 'Feel The Dumbbell Fly MORE | Targeting The Muscle',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'low-cable-fly': [
    {
      youtubeId: '-J7ejdxzI2I',
      title: 'Cómo ESTIMULAR tus PECTORALES al MÁXIMO (Cruces de Polea)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: '-EIhKMDSjBY',
      title: 'The Best Way To Isolate The Chest For Growth (Upper Chest Focus)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'cable-crossover': [
    {
      youtubeId: 's1F13ILGM6s',
      title: 'PECTORAL - Cruce de Poleas ejercicio entrenamiento pecho',
      channel: 'Bilbo Team Jesus Maria Varela',
      lang: 'es',
    },
    {
      youtubeId: 'JUDTGZh4rhg',
      title: 'STOP F*cking Up Cable Flys (PROPER FORM!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'pec-deck': [
    {
      youtubeId: 'Om6ABTzZrQY',
      title: 'APERTURAS DE PECHO EN MAQUINA. PECTORALES.',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'O-OBCfyh9Fw',
      title: 'Pec Deck Flye',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'machine-chest-press': [
    {
      youtubeId: 'v4XTkt2CURc',
      title: 'PRESS PLANO EN MÁQUINA – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'SUdQ1roIWz0',
      title: 'Get The Most Out Of Chest Machines | Targeting The Muscle',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'smith-incline-press': [
    {
      youtubeId: '8urE8Z8AMQ4',
      title: 'Smith Machine Incline Press',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
    {
      youtubeId: 'fGm-ef-4PVk',
      title: 'The Best And Worst Chest Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  dips: [
    {
      youtubeId: '1Vm1ATIi0AE',
      title:
        'FONDOS EN PARALELAS (DIPS) - TECNICA, ERRORES, CONSEJOS ... (Todo sobre los fondos en paralelas)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'yN6Q1UI_xkE',
      title: 'How To Do Dips For A Bigger Chest and Shoulders (Fix Mistakes!)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'push-up': [
    {
      youtubeId: '1uXurwfvn_o',
      title: 'Nunca hagas FLEXIONES ASÍ - Los 7 ERRORES al hacer flexiones',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'IODxDxX7oi4',
      title: 'The Perfect Push Up | Do it right!',
      channel: 'Calisthenicmovement',
      lang: 'en',
    },
  ],
  deadlift: [
    {
      youtubeId: 'kancsOn7CJY',
      title: 'Cómo hacer PESO MUERTO CONVENCIONAL como un PROFESIONAL (guía completa)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'VL5Ab0T07e4',
      title: 'Build A Bigger Deadlift With Perfect Technique (Conventional Form)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'sumo-deadlift': [
    {
      youtubeId: 'zYQJqiZ2zE0',
      title: 'Cómo hacer PESO MUERTO SUMO al MÁXIMO NIVEL (Guía Completa Powerlifting)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'XsrD5y8EIKU',
      title:
        'The Most Effective Way to Deadlift for Muscle and Strength (Sumo Technique Explained)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'pendlay-row': [
    {
      youtubeId: 'axoeDmW0oAY',
      title: 'How To Build a Thick Back With Perfect Rowing Technique (Pendlay Row/ Helms Row)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'barbell-row': [
    {
      youtubeId: 'qsbJcaAneaw',
      title: 'CÓMO HACER REMO CON BARRA -TODO SOBRE LA TÉCNICA DEL REMO CON BARRA',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'T3N-TO4reLQ',
      title: 'How to do Barbell Rows PROPERLY for a Big Back (AVOID MISTAKES!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  't-bar-row': [
    {
      youtubeId: 'GEgmkhrQgUM',
      title: 'MÁQUINA REMO EN T – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: '5foJiIVhs8Q',
      title: 'How To T-Bar Row The Right Way! (BACK BUILDER!)',
      channel: 'Mind Pump TV',
      lang: 'en',
    },
  ],
  'one-arm-dumbbell-row': [
    {
      youtubeId: 'fZYGcNtMWSc',
      title: 'Cómo Hacer REMO CON MANCUERNA Perfecto (paso a paso)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'djKXLt7kv7Q',
      title: 'How To Do Dumbbell Rows: Build a Thicker Back With Proper "Cheating"',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'seated-cable-row': [
    {
      youtubeId: 'sP_4vybjVJs',
      title: 'How To Properly Do The Seated Cable Row (IT MATTERS!)',
      channel: 'Mind Pump TV',
      lang: 'en',
    },
  ],
  'pull-up': [
    {
      youtubeId: 'K-g9y7lyQ-o',
      title: 'Guía COMPLETA para hacer DOMINADAS: descubre sus secretos, errores y consejos',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'eGo4IYlbE5g',
      title: 'The Perfect Pull Up  - Do it right!',
      channel: 'Calisthenicmovement',
      lang: 'en',
    },
  ],
  'chin-up': [
    {
      youtubeId: 'UfhT0OSUU0w',
      title: 'Pull Up vs. Chin Up | Which One Is Better For You?',
      channel: 'Calisthenicmovement',
      lang: 'en',
    },
  ],
  'lat-pulldown': [
    {
      youtubeId: 'EO9AmI-bu_0',
      title: 'Cómo hacer Jalón al Pecho para Dorsal (sin errores)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'SALxEARiMkw',
      title: 'How to do Lat Pulldowns (AVOID MISTAKES!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'assisted-pull-up-machine': [
    {
      youtubeId: 'lgE47t3dr2Q',
      title: 'DOMINADAS Asistidas en MÁQUINA TUTORIAL',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'vKpqOpjJt18',
      title: '9 Assisted Pull Up Mistakes and How to Fix Them',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'close-grip-pulldown': [
    {
      youtubeId: 'VUJYixXx5I8',
      title: 'Jalón al Pecho con Polea Alta Cerrado Agarre Neutro',
      channel: 'Zonapablo',
      lang: 'es',
    },
  ],
  'cable-serratus': [
    {
      youtubeId: '-UrSFw0QPHs',
      title: 'PULL OVER con CUERDA en Polea Alta',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'G9uNaXGTJ4w',
      title: 'Straight Arm Pulldown',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'plate-loaded-row': [
    {
      youtubeId: 'Biv8gstT6VQ',
      title: 'REMO EN MÁQUINA DE DISCOS – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
  ],
  'plate-loaded-high-row': [
    {
      youtubeId: 'gg5hwJuv6KI',
      title: 'Hammer High Row',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'chest-supported-dumbbell-row': [
    {
      youtubeId: 'D6lpHgyDItk',
      title: 'Remo con 2 Mancuernas en Banco Inclinado',
      channel: 'Zonapablo',
      lang: 'es',
    },
  ],
  'dumbbell-pullover': [
    {
      youtubeId: '5XO5KyDUAbE',
      title:
        'PULLOVER CON MANCUERNA: TÉCNICA, PELIGROS Y ERRORES [Entrenamiento de pectorales y espalda]',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'jQjWlIwG4sI',
      title: 'Dumbbell Pullover',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'back-extension': [
    {
      youtubeId: 'nMiVlx_gUzQ',
      title: '¡NO hagas extensiones de espalda de esta forma!',
      channel: 'Squat University Español',
      lang: 'es',
    },
    {
      youtubeId: 'H8Swl1N-uis',
      title: 'STOP Doing Back Extensions Like This!',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'good-morning': [
    {
      youtubeId: 'RXt4oK5oWnY',
      title: 'BUENOS DÍAS CON BARRA LIBRE – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'f23vXjoG2e8',
      title:
        'HOW TO DO THE GOOD MORNING EXERCISE: Build Your Glutes, Hamstrings And Squat With Perfect Technique',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'barbell-shrug': [
    {
      youtubeId: 'zfAHfyTB_Ao',
      title: 'Barbell Shrug Technique For Growth | Targeting The Muscle',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'dumbbell-shrug': [
    {
      youtubeId: '_t3lrPI6Ns4',
      title: 'Dumbbell Shrug',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'overhead-press': [
    {
      youtubeId: 'j_Buh54Sb-w',
      title: 'PRESS MILITAR - (TÉCNICA, CONSEJOS, ERRORES COMUNES ETC.)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: '_RlRDWO2jfg',
      title: 'Build Bigger Shoulders With Perfect Training Technique (The Overhead Press)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'seated-dumbbell-press': [
    {
      youtubeId: 'o5M9RZ-vWrc',
      title: 'PRESS MILITAR con Mancuernas 🏋️‍♂️ Mejora tu Técnica',
      channel: 'HSNstore.com',
      lang: 'es',
    },
  ],
  'arnold-press': [
    {
      youtubeId: 'V8GcUp4COLg',
      title: 'No Arruines el Press Arnold ¡FORMA CORRECTA!',
      channel: 'ATHLEAN-X Español',
      lang: 'es',
    },
    {
      youtubeId: 'ris9tKqMwgU',
      title: 'Stop F*cking Up The Arnold Press (PROPER FORM!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'machine-shoulder-press': [
    {
      youtubeId: 'WvLMauqrnK8',
      title: 'Machine Shoulder Press',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'plate-loaded-shoulder-press': [
    {
      youtubeId: 'lXr3MejFPuE',
      title: 'PRESS MILITAR EN MÁQUINA DE DISCOS – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'X0SteQbRbCo',
      title: 'Hammer Strength Plate-Loaded Shoulder Press Instructions',
      channel: 'Life Fitness / Hammer Strength',
      lang: 'en',
    },
  ],
  'smith-shoulder-press': [
    {
      youtubeId: 'OLqZDUUD2b0',
      title: 'Smith Machine Seated Shoulder Press',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'dumbbell-lateral-raise': [
    {
      youtubeId: 'HldK_19NDEI',
      title: 'Cómo desarrollar HOMBROS más ANCHOS Y REDONDOS (Elevaciones Laterales)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'q5sNYB1Q6aM',
      title: 'Rotator Cuff Killer (SHOULDER LATERAL RAISES!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'cable-lateral-raise': [
    {
      youtubeId: 'jp070OTX3pA',
      title: 'ELEVACIONES LATERALES en polea: El mejor ajuste para tu DELTOIDES LATERAL',
      channel: 'Trainologym',
      lang: 'es',
    },
  ],
  'machine-lateral-raise': [
    {
      youtubeId: '0o07iGKUarI',
      title: 'Machine Lateral Raise',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'front-raise': [
    {
      youtubeId: 'joO2vLGujcA',
      title: 'Haz las ELEVACIONES FRONTALES correctamente',
      channel: 'Powerexplosive',
      lang: 'es',
    },
  ],
  'reverse-pec-deck': [
    {
      youtubeId: '5YK4bgzXDp0',
      title: 'Machine Reverse Flye',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'rear-delt-dumbbell-fly': [
    {
      youtubeId: '1yMpNpVgItU',
      title: 'Trabaja el Deltoides Posterior 💪🏻 [La guía más completa]',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'dKluhLck1Zs',
      title: 'The ONLY 2 Exercises You Need for Rear Delts (NO, SERIOUSLY!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'face-pull': [
    {
      youtubeId: 'X-xCQ1gh-kA',
      title: 'Cómo Hacer Face Pull Correctamente 💪 ¡Evita lesiones! con Powerexplosive',
      channel: 'HSNstore.com',
      lang: 'es',
    },
    {
      youtubeId: 'ljgqer1ZpXg',
      title: 'STOP F*cking Up Face Pulls (PROPER FORM!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'upright-row': [
    {
      youtubeId: 'loL670Yb7nU',
      title: 'HOMBRO y TRAPECIO GRANDES - Remo al mentón (mi ejercicio estrella)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'nwkLwMRHMQo',
      title: 'How To Fix The Upright Row: Avoid Shoulder Pain & Maximize Growth',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'barbell-curl': [
    {
      youtubeId: 'oHO6dV7aQbE',
      title:
        'CURL DE BICEPS: TÉCNICA PARA EL MÁXIMO DESARROLLO DEL BÍCEPS (EJECUCIÓN, TRUCOS, CONSEJOS, ERRORES…)',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'jjnJHhzZUUM',
      title: 'STOP Doing Bicep Curls Like This (5 Mistakes Slowing Your Gains)',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
  ],
  'ez-bar-curl': [
    {
      youtubeId: '8yUnK_7U2ow',
      title: 'CURL DE BÍCEPS DE PIE CON BARRA Z – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'tJIFTI9wZOw',
      title: 'EZ Bar Curl For Growth | Targeting The Muscle',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'dumbbell-curl': [
    {
      youtubeId: 'STq4k6wWrTY',
      title: 'CURL DE BICEPS: Guía COMPLETA para MUTAR tus BÍCEPS',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'yTWO2th-RIY',
      title: 'Stop Doing Dumbbell Bicep Curls Like This!',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'hammer-curl': [
    {
      youtubeId: 'znTSJ_2zJN0',
      title: 'CURL MARTILLO CON MANCUERNA – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: '8XLxfXROrTo',
      title: 'HOW TO: Dumbbell Hammer Curl (BICEPS PEAK BUILDER!) || PERFECT FORM',
      channel: 'ScottHermanFitness',
      lang: 'en',
    },
  ],
  'incline-dumbbell-curl': [
    {
      youtubeId: 'ZY19YNmm7tQ',
      title: 'CURL de BÍCEPS en BANCO INCLINADO ¡Hazlo así!',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'DCe8f6vMe9A',
      title: 'Stop Screwing Up Incline Dumbbell Curls (PROPER FORM!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'preacher-curl': [
    {
      youtubeId: 'rFbuiBgWCYE',
      title: 'Curl Bíceps Predicador Barra Z',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: '7v7uldi1eLU',
      title: 'Preacher Curls Are What Your Bicep Workouts Have Been Missing!',
      channel: 'Mind Pump TV',
      lang: 'en',
    },
  ],
  'machine-preacher-curl': [
    {
      youtubeId: 'U1iY5dCxggg',
      title: 'Bíceps Predicador en Máquina',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'Ja6ZlIDONac',
      title: 'Machine Preacher Curl',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'concentration-curl': [
    {
      youtubeId: 'WdbkH_k5DWs',
      title: 'Bíceps: CURL CONCENTRADO - Técnica y errores',
      channel: 'Natalia Melle - Fisioterapeuta y Entrenadora',
      lang: 'es',
    },
    {
      youtubeId: 'ebqgIOiYGEY',
      title: "Concentration Curls Aren't Working for You (HERE'S WHY!)",
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'spider-curl': [
    {
      youtubeId: 'fBqxyvCiiXs',
      title: 'CURL DE BÍCEPS ARAÑA 🕷️ ¡Aumenta tus BÍCEPS con este ejercicio!',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'ke2shAeQ0O8',
      title: 'Dumbbell Spider Curl',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'bayesian-curl': [
    {
      youtubeId: 'pf5IukGgKk4',
      title: 'CURL BAYESIAN UNILATERAL I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'GNO4OtYoCYk',
      title: 'The Best And Worst Biceps Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'skull-crusher': [
    {
      youtubeId: 'Zd6LaSowRdc',
      title: 'Tríceps Frances con Barra Z',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'l3rHYPtMUo8',
      title: 'Barbell Skullcrusher',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'triceps-pushdown': [
    {
      youtubeId: 'HAS8uy73HqM',
      title: 'Extensión de Tríceps en Polea - Técnica Perfecta- Galvistrainer',
      channel: 'Galvistrainer',
      lang: 'es',
    },
    {
      youtubeId: '7R88yqmcGrw',
      title: 'Which Triceps Pushdown is Best for Your Triceps (IT MATTERS!!)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'rope-pushdown': [
    {
      youtubeId: 'uZg6VtRhwQY',
      title: 'Tríceps en Polea con Cuerdas / Tips Claves',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: '-xa-6cQaZKY',
      title: 'Rope Pushdown',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'overhead-cable-extension': [
    {
      youtubeId: 'P40-DvgM9qI',
      title: 'Tríceps Tras nuca en Polea Baja - Extensión de tríceps sobre la cabeza',
      channel: 'Zonapablo',
      lang: 'es',
    },
  ],
  'bench-dip': [
    {
      youtubeId: 'jdFzYGmvDyg',
      title: 'Stop Doing Bench Dips Like This!',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'farmer-walk': [
    {
      youtubeId: 'X72HhVGAko4',
      title: 'I LOVE Farmer Walks!',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  squat: [
    {
      youtubeId: '0rgiePufo0A',
      title: 'CÓMO HACER SENTADILLAS -TODO SOBRE LA TÉCNICA',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'my0tLDaWyDU',
      title: 'How To Squat Correctly (NO BACK PAIN)',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'front-squat': [
    {
      youtubeId: 'KXhu0HkJ7K4',
      title: 'Cómo Hacer Sentadillas Frontales Con Técnica Perfecta (Evita Estos Errores)',
      channel: 'Squat University Español',
      lang: 'es',
    },
    {
      youtubeId: '7pyxT5hqmQY',
      title: 'How To Front Squat (WAYS TO KEEP YOUR CHEST UP!)',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'smith-squat': [
    {
      youtubeId: 'fEuYM-miK5U',
      title: '9 Smith Machine Squat Mistakes and How to Fix Them',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'hack-squat': [
    {
      youtubeId: 'gbiFASQfvEc',
      title: 'Maximiza tus resultados en piernas con la Máquina Jaca',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: '4cxt_Tldugw',
      title: '9 Hack Squat Mistakes and How to Fix Them',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'leg-press': [
    {
      youtubeId: 'SBynQ6-DyKo',
      title: 'Consigue PIERNAS GRANDES con ESTE EJERCICIO (Prensa Inclinada)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'B6rGDcfyPto',
      title: 'How To Leg Press For Best Quad Growth | Targeting The Muscle Series',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'horizontal-leg-press': [
    {
      youtubeId: 'A1w2pmWT6ms',
      title: '3 CLAVES sobre la PRENSA Horizontal',
      channel: 'Mundo Entrenamiento',
      lang: 'es',
    },
  ],
  'bulgarian-split-squat': [
    {
      youtubeId: '6d6HlPWgAUs',
      title: 'Piernas y Glúteos DE ACERO con la SENTADILLA BÚLGARA perfecta',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'hPlKPjohFS0',
      title: 'The PERFECT Bulgarian Split Squat (Avoid These Errors!)',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'walking-lunge': [
    {
      youtubeId: '-iGRWD09Jn8',
      title: 'Zancada con Mancuernas para PIERNAS y GLÚTEOS',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'Pwsn3HR4L90',
      title: 'Stop Doing Lunges Like This! (SAVE A FRIEND)',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'leg-extension': [
    {
      youtubeId: 'ljO4jkwv8wQ',
      title: 'How To Do Leg Extensions With Perfect Technique (Grow Every Quad Head)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'lying-leg-curl': [
    {
      youtubeId: 'jobEeklwrrs',
      title: '9 Leg Curl Mistakes and How to Fix Them',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'seated-leg-curl': [
    {
      youtubeId: 'Orxowest56U',
      title: 'Seated Leg Curl',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
    {
      youtubeId: 'vgR9WTxIZTk',
      title: 'Should You Lean Forward for Seated Leg Curls? With Hypertrophy Coach',
      channel: 'Hypertrophy Coach',
      lang: 'en',
    },
  ],
  'romanian-deadlift': [
    {
      youtubeId: 'rjvlSfZ-PQw',
      title: 'Cómo Hacer PESO MUERTO RUMANO Perfecto (paso a paso)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: '_oyxCn2iSjU',
      title: 'HOW TO DO ROMANIAN DEADLIFTS (RDLs): Build Beefy Hamstrings With Perfect Technique',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'hip-thrust': [
    {
      youtubeId: 'lmUx6WAV-BQ',
      title: 'Cómo construir GLÚTEOS GRANDES Y FUERTES con HIP THRUST (técnica avanzada)',
      channel: 'Fit Generation',
      lang: 'es',
    },
    {
      youtubeId: 'xDmFkJxPzeM',
      title: 'How To Build Great Glutes with Perfect Hip Thrust Technique (Fix Mistakes!)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'machine-hip-thrust': [
    {
      youtubeId: 'ZSPmIyX9RZs',
      title: 'Machine Hip Thrust',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'cable-glute-kickback': [
    {
      youtubeId: 'frL1ODvCZWM',
      title: 'Patada  de Glúteo en Polea',
      channel: 'Zonapablo',
      lang: 'es',
    },
    {
      youtubeId: 'dJa_Nf4zdik',
      title:
        'Build Bigger Glutes With Perfect Training Technique ft. Stephanie Buttermore (Glute Kickback)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'machine-glute-kickback': [
    {
      youtubeId: 'RT5ZuVCy5Ac',
      title: 'Patada de GLÉTEO en MÁQUINA.  Cómo congestionar Glúteos al Máximo',
      channel: 'Zonapablo',
      lang: 'es',
    },
  ],
  'cable-pull-through': [
    {
      youtubeId: 'ieNv0CCbfKw',
      title: 'Pull Through en Polea I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'pv8e6OSyETE',
      title: 'Cable Pull Through',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'kettlebell-swing': [
    {
      youtubeId: '3YDtpRWJISI',
      title: '¡Todos están haciendo mal el swing con kettlebell!',
      channel: 'Squat University Español',
      lang: 'es',
    },
    {
      youtubeId: 'LBhaLLc153A',
      title: 'The Kettlebell Swing Technique Everyone Gets WRONG!',
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'standing-calf-raise': [
    {
      youtubeId: '1H-k_qhur-g',
      title: 'Cómo Conseguir Gemelos GRANDES (sin importar tu genética)',
      channel: 'Fit Generation',
      lang: 'es',
    },
  ],
  'leg-press-calf-raise': [
    {
      youtubeId: 'KxEYX_cuesM',
      title: 'Leg Press Calves',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  plank: [
    {
      youtubeId: '5JMakqxdT5c',
      title: 'CÓMO HACER ABDOMINALES: PLANCHA ABDOMINAL PERFECTA',
      channel: 'Powerexplosive',
      lang: 'es',
    },
    {
      youtubeId: 'kL_NJAkCQBg',
      title: 'Mastering the Plank - In Just 2 Minutes',
      channel: 'Calisthenicmovement',
      lang: 'en',
    },
  ],
  'ab-wheel': [
    {
      youtubeId: 'J8QEQ_FZqIU',
      title: 'RUEDA ABDOMINAL: ¡¡NO LA ESTÁS HACIENDO BIEN!!',
      channel: 'Escuela Culturismo Natural',
      lang: 'es',
    },
    {
      youtubeId: 'A3uK5TPzHq8',
      title: 'Never Do Ab Wheel Rollouts Like This!',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'cable-crunch': [
    {
      youtubeId: 'ui3iEsYbXtI',
      title: 'Crunches abdominales en polea - Técnica correcta✅ - Galvistrainer',
      channel: 'Galvistrainer',
      lang: 'es',
    },
  ],
  'hanging-leg-raise': [
    {
      youtubeId: '_QMu7MSAYQg',
      title: 'Elevación de Pierna para Abdomen Colgado I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'Pr1ieGZ5atk',
      title: 'Hanging Leg Raise | HOW-TO',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  crunch: [
    {
      youtubeId: 'zkQWXbAP9l0',
      title: 'NEVER DO CRUNCHES LIKE THIS | 10 Most Common Mistakes!',
      channel: 'ATHLEAN-X™',
      lang: 'en',
    },
  ],
  'dead-bug': [
    {
      youtubeId: '0XVbn86Btj0',
      title: "You're Doing Dead Bugs WRONG! Fix This for Stronger Abs & a Bulletproof Core",
      channel: 'Squat University',
      lang: 'en',
    },
  ],
  'rowing-machine': [
    {
      youtubeId: '4zWu1yuJ0_g',
      title: 'Correct Rowing Machine Technique, Improve Your Rowing  | Concept2',
      channel: 'concept2usa',
      lang: 'en',
    },
  ],
  'cable-lat-pull-around': [
    {
      youtubeId: 'tqLrIh0lINU',
      title: 'Jalón unilateral CRUZADO',
      channel: 'Entrena con LadyKiller®️',
      lang: 'es',
    },
    {
      youtubeId: '4xHF_pMbEsk',
      title: 'How To: ½ Kneeling Cable Cross Body Lat Pull Around',
      channel: 'Live Lean TV Daily Exercises',
      lang: 'en',
    },
    {
      youtubeId: 'jLvqKgW-_G8',
      title: 'The Best And Worst Back Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
      start: 278,
    },
  ],
  'half-kneeling-single-arm-pulldown': [
    {
      youtubeId: '1hoM0hcSszc',
      title: 'JALÓN UNILATERAL de RODILLAS en POLEA',
      channel: 'POWER HIIT FITNESS COACHING',
      lang: 'es',
    },
    {
      youtubeId: 'jLvqKgW-_G8',
      title: 'The Best And Worst Back Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'lat-prayer': [
    {
      youtubeId: '50McGQ3MJOY',
      title: 'Lat Prayer with Menno Henselmans',
      channel: 'Menno Henselmans',
      lang: 'en',
    },
    {
      youtubeId: '_XxdZcR_Iyw',
      title: 'Lat Prayer Tutorial – Build a Stronger, Wider Back',
      channel: 'FIT.nl',
      lang: 'en',
    },
  ],
  'cable-y-raise': [
    {
      youtubeId: 'OXWBrhMa590',
      title: 'ELEVACIONES LATERALES CRUZADAS en POLEA',
      channel: 'POWER HIIT FITNESS COACHING',
      lang: 'es',
    },
    {
      youtubeId: '9D1c_EVhM-o',
      title: 'Cable Y Raise - The Ultimate Shoulder Exercise',
      channel: 'FormFocus',
      lang: 'en',
    },
    {
      youtubeId: 'SgyUoY0IZ7A',
      title: 'The Best And Worst Shoulder Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'behind-back-cable-lateral-raise': [
    {
      youtubeId: 'jM8p44gwFPw',
      title: '¡Los ÚNICOS 2 ejercicios que hicieron crecer mis hombros estrechos 💪🏼🔥',
      channel: 'Jeremy Ethier en Español',
      lang: 'es',
    },
    {
      youtubeId: 'ozpcrgmwyto',
      title: 'The ONLY 2 Exercises You Need For Wide Shoulders',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
    {
      youtubeId: 'SgyUoY0IZ7A',
      title: 'The Best And Worst Shoulder Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'super-rom-lateral-raise': [
    { youtubeId: 'C666hpsFvJY', title: 'Elevaciones Lu', channel: 'Víctor Sánchez', lang: 'es' },
    {
      youtubeId: 'O9oicEA7aPU',
      title: 'Do Lu Raises For Bigger Shoulders',
      channel: 'FitnessFAQs',
      lang: 'en',
    },
    {
      youtubeId: 'WksbcaxSp2c',
      title: 'Everyone Trains Traps WRONG (5 BETTER Trap Exercises)',
      channel: 'Renaissance Periodization',
      lang: 'en',
    },
  ],
  'side-lying-incline-lateral-raise': [
    {
      youtubeId: '-znJNdPnaOo',
      title: 'Exercise Index - Lying Side Raise',
      channel: 'mountaindog1',
      lang: 'en',
    },
    {
      youtubeId: 'SgyUoY0IZ7A',
      title: 'The Best And Worst Shoulder Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'lean-in-lateral-raise': [
    {
      youtubeId: 'jM8p44gwFPw',
      title: '¡Los ÚNICOS 2 ejercicios que hicieron crecer mis hombros estrechos 💪🏼🔥',
      channel: 'Jeremy Ethier en Español',
      lang: 'es',
    },
    {
      youtubeId: 'ozpcrgmwyto',
      title: 'The ONLY 2 Exercises You Need For Wide Shoulders',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
    {
      youtubeId: 'SgyUoY0IZ7A',
      title: 'The Best And Worst Shoulder Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'katana-triceps-extension': [
    {
      youtubeId: 'FCATldkFCUk',
      title:
        'TUTORIAL del MEJOR ejercicio de TRÍCEPS -y variantes- EXTENSIONES KATANA paso a paso - 2025',
      channel: 'Sergio M. Coach',
      lang: 'es',
    },
    {
      youtubeId: 'OpRMRhr0Ycc',
      title: 'The Best & Worst TRICEPS Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'smith-jm-press': [
    {
      youtubeId: 'b-nyTZBLpWo',
      title: 'Domina el JM Press en Smith: Paso a Paso',
      channel: 'Profit Tec',
      lang: 'es',
    },
    {
      youtubeId: '6oaUT4GYHkw',
      title: 'How to: Smith Machine JM Press | BEST GUIDE & TIPS!',
      channel: 'ATLASTHETICS',
      lang: 'en',
    },
    {
      youtubeId: 'OpRMRhr0Ycc',
      title: 'The Best & Worst TRICEPS Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'cable-triceps-kickback': [
    {
      youtubeId: 'p31eAveVGk8',
      title: 'PATADA DE TRICEPS EN POLEA I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'OpRMRhr0Ycc',
      title: 'The Best & Worst TRICEPS Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'cable-press-around': [
    {
      youtubeId: '8Ra0swX5-zg',
      title: 'Press-Around Tutorial (Short Postion Pec Training)',
      channel: 'Ben Yanes',
      lang: 'en',
    },
    {
      youtubeId: 'fGm-ef-4PVk',
      title: 'The Best And Worst Chest Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'helms-row': [
    { youtubeId: 'F6UaTLjkLBk', title: 'REMO HELMS', channel: 'EPD Prof.Patriciodiaz', lang: 'es' },
    {
      youtubeId: 'axoeDmW0oAY',
      title: 'How To Build a Thick Back With Perfect Rowing Technique (Pendlay Row/ Helms Row)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'kelso-shrug': [
    {
      youtubeId: 'PAYCldv_IhE',
      title: 'Encogimientos Kelso',
      channel: 'Víctor Sánchez',
      lang: 'es',
    },
    {
      youtubeId: 'zX0c-WIIilk',
      title: 'Dumbbell Kelso Shrugs (Chest Supported Shrugs)',
      channel: 'The Neuro Strength Coach',
      lang: 'en',
    },
  ],
  'kroc-row': [
    {
      youtubeId: 'lL6fOrEPvQI',
      title:
        'Kroc Rows Technique - Building Upper Back Size and Strength w/ Heavy, High Rep One Arm Dumbbell Rows',
      channel: 'Alexander Bromley',
      lang: 'en',
    },
    {
      youtubeId: 'jLvqKgW-_G8',
      title: 'The Best And Worst Back Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'seal-row': [
    {
      youtubeId: '3MzKh7bVoo0',
      title: 'SEAL ROW CON MANCUERNAS',
      channel: 'CARLOS Online Coach',
      lang: 'es',
    },
    {
      youtubeId: 'fBgDGkfT8Rc',
      title: 'Exercise Index - Seal Rows',
      channel: 'mountaindog1',
      lang: 'en',
    },
  ],
  'meadows-row': [
    {
      youtubeId: 'HAUniv35zGY',
      title: 'REMO MEADOWS  I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'G-jU1aPVhnY',
      title: 'How to Meadows Row "The Right Way"',
      channel: 'mountaindog1',
      lang: 'en',
    },
  ],
  'wide-grip-cable-row': [
    {
      youtubeId: 'nCbtqkECvFI',
      title: 'Remo Polea Sentado Agarre Prono ABIERTO',
      channel: 'Intenza Gym ',
      lang: 'es',
    },
    {
      youtubeId: 'jLvqKgW-_G8',
      title: 'The Best And Worst Back Exercises (Ranked By Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'pendulum-squat': [
    {
      youtubeId: 'mr9-sHJg2hE',
      title: 'SENTADILLA PENDULAR – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'kIXcoivzGf8',
      title: 'The Best & Worst QUAD Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'sissy-squat': [
    {
      youtubeId: 'IU6w5NDjNxE',
      title: 'SISSY SQUAT o SENTADILLA SISSY sin máquina para CUÁDRICEPS | CÓMO SE HACE',
      channel: 'APTA Vital Sport',
      lang: 'es',
    },
    {
      youtubeId: 'sMOmCcjS-Js',
      title: 'Sissy Squats Will Transform Your Legs',
      channel: 'FitnessFAQs',
      lang: 'en',
    },
    {
      youtubeId: 'kIXcoivzGf8',
      title: 'The Best & Worst QUAD Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'reverse-nordic': [
    {
      youtubeId: 'ymYl3zpyVU0',
      title: 'curl nórdico invertido (reverse nordic curl)',
      channel: 'Fitness Consciente',
      lang: 'es',
    },
    {
      youtubeId: 'PvJDjcfZe1c',
      title:
        'How to Safely Set Up, Perform, & Program Reverse Nordics (Progressions | Regressions | Alternatives)',
      channel: 'E3 Rehab',
      lang: 'en',
    },
    {
      youtubeId: 'kIXcoivzGf8',
      title: 'The Best & Worst QUAD Exercises (Ranked Using Science)',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'nordic-curl': [
    {
      youtubeId: 'Vd6HJ3FsBEw',
      title:
        'Isquios más FUNCIONALES y sin LESIONES con este ejercicio ✅ CURL NÓRDICO – CAÍDAS NÓRDICAS',
      channel: 'Ninolift',
      lang: 'es',
    },
    {
      youtubeId: '6NCN6kOagfY',
      title: 'How to Do a Nordic Hamstring Curl',
      channel: 'The Kneesovertoesguy',
      lang: 'en',
    },
  ],
  'copenhagen-plank': [
    {
      youtubeId: 'mv8u-RDoADM',
      title: 'Plancha Copenhague para Aductor I Explicación Completa I Sergio Tejeda',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'YRRnnZsRs9U',
      title:
        'How to Set Up, Perform, & Program Copenhagen Planks (Progressions | Regressions | Alternatives)',
      channel: 'E3 Rehab',
      lang: 'en',
    },
  ],
  'deficit-bulgarian-split-squat': [
    {
      youtubeId: 'x4LnQD6I264',
      title: 'SENTADILLA BÚLGARA CON DÉFICIT – TÉCNICA CORRECTA, BENEFICIOS Y ERRORES COMUNES',
      channel: 'Sergio Tejeda',
      lang: 'es',
    },
    {
      youtubeId: 'cyXeMojvQ9s',
      title: 'How to: Deficit Bulgarian Split Squat',
      channel: 'Core Blend Training',
      lang: 'en',
    },
  ],
  'atg-split-squat': [
    {
      youtubeId: 'g6KrlrOq4mw',
      title: 'Build Strength and Flexibility with This One Brutal Leg Move | Knees Over Toes Guy',
      channel: 'Garage Strength',
      lang: 'en',
    },
  ],
  'tibialis-raise': [
    {
      youtubeId: 'UVh1ztx8kZI',
      title: 'Elevaciones de tibial anterior - Técnica',
      channel: 'Academia de Movimiento',
      lang: 'es',
    },
    {
      youtubeId: '_2RZkfw6Y1g',
      title: 'ATG Foot, Ankle, Achilles & Shin Guide',
      channel: 'The Kneesovertoesguy',
      lang: 'en',
    },
  ],
  'frog-pump': [
    {
      youtubeId: 'QZypmmBVsh0',
      title: 'FROG PUMP 🍑Activa y Aumenta tus GLÚTEOS con este Ejercicio ✅',
      channel: 'Ninolift',
      lang: 'es',
    },
    {
      youtubeId: 'jbJBXErKD-U',
      title: 'How To Frog Pump',
      channel: 'Bret Contreras Glute Guy',
      lang: 'en',
    },
  ],
  'spanish-squat': [
    {
      youtubeId: 'CYIds8CzGbU',
      title: 'SENTADILLA ESPAÑOLA CON GOMA',
      channel: 'Pau Mérida',
      lang: 'es',
    },
    {
      youtubeId: 'hgFxm5KIF7M',
      title: "How to Set Up and Perform Spanish Squats Correctly (Don't Make This Mistake!)",
      channel: 'E3 Rehab',
      lang: 'en',
    },
  ],
  'lying-dumbbell-curl': [
    {
      youtubeId: '8e5gLPyFAz4',
      title: '💪 ¡Los ÚNICOS 2 ejercicios que necesitas para brazos gigantes! 🔥',
      channel: 'Jeremy Ethier en Español',
      lang: 'es',
    },
    {
      youtubeId: 'WvlDMlMx1Ok',
      title: 'The ONLY 2 Exercises You Need For Massive Arms',
      channel: 'Jeremy Ethier',
      lang: 'en',
    },
    {
      youtubeId: 'GNO4OtYoCYk',
      title: 'The Best And Worst Biceps Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'inverse-zottman-curl': [
    {
      youtubeId: 'LIJFwB5NwPs',
      title: 'How To: Standing Inverse Zottman Curl',
      channel: 'Live Lean TV Daily Exercises',
      lang: 'en',
    },
    {
      youtubeId: 'GNO4OtYoCYk',
      title: 'The Best And Worst Biceps Exercises',
      channel: 'Jeff Nippard',
      lang: 'en',
    },
  ],
  'b-stance-rdl': [
    {
      youtubeId: 'n48GjINLCe4',
      title: 'Peso Muerto Rumano B Stance ✅ Todo lo que NECESITAS SABER',
      channel: 'Ninolift',
      lang: 'es',
    },
    {
      youtubeId: 'SwQtQvcrz-c',
      title: 'How To Properly B Stance RDL For More Glute Gains (Learn In 3 Minutes)',
      channel: 'Colossus Fitness',
      lang: 'en',
    },
  ],
}
